import { PropsWithChildren, useContext } from 'react';

import {
  useIsClusterDemoMode,
  useIsOpDemoMode,
  useIsSecurityDemoMode,
} from '@cast/infrastructure-demo';

import { EnableSecurityBanner } from './EnableSecurityBanner';
import { SecurityDemoProviderContext } from '../SecurityDemoProvider';

import { Stack } from '@cast/design-system';
import type { StackProps } from '@cast/design-system';

type SecurityPageContainerProps = PropsWithChildren<StackProps> & {
  isLoading?: boolean;
};

export const SecurityPageContainer = ({
  children,
  isLoading = false,
  ...props
}: SecurityPageContainerProps) => {
  const { isBannerDismissed, onBannerDismiss } = useContext(
    SecurityDemoProviderContext
  );
  const isClusterDemoMode = useIsClusterDemoMode();
  const isOpDemoMode = useIsOpDemoMode();
  const isSecurityDemo = useIsSecurityDemoMode();
  const showBanner =
    !isClusterDemoMode &&
    !isOpDemoMode &&
    isSecurityDemo &&
    !isLoading &&
    !isBannerDismissed;

  return (
    <>
      {showBanner && <EnableSecurityBanner onDismiss={onBannerDismiss} />}
      <Stack
        sx={
          showBanner
            ? {
                filter: 'blur(10px)',
                pointerEvents: 'none',
                userSelect: 'none',
              }
            : undefined
        }
        {...props}
      >
        {children}
      </Stack>
    </>
  );
};
